<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import BulkPopover from './BulkPopover.vue';

const emit = defineEmits(['assignTeam', 'close']);

const { t } = useI18n();
const teams = useMapGetter('teams/getTeams');

const query = ref('');

const filteredTeams = computed(() => {
  const termo = query.value.trim().toLowerCase();
  return teams.value.filter(team => team.name.toLowerCase().includes(termo));
});

// `id: 0` é o "tirar do time" que o servidor entende. O nome era "None", em
// inglês, no meio da lista em português.
const semTime = computed(() => ({ id: 0, name: t('BULK_ACTION.TEAMS.NONE') }));
</script>

<template>
  <BulkPopover
    :titulo="t('BULK_ACTION.TEAMS.TEAM_SELECT_LABEL')"
    @close="emit('close')"
  >
    <template v-if="teams.length">
      <label class="advup-busca advup-busca--bloco bta-busca">
        <i class="i-lucide-search advup-busca__lupa" aria-hidden="true" />
        <input
          v-model="query"
          type="search"
          class="advup-busca__campo reset-base"
          :placeholder="t('BULK_ACTION.SEARCH_INPUT_PLACEHOLDER')"
          :aria-label="t('BULK_ACTION.SEARCH_INPUT_PLACEHOLDER')"
        />
      </label>
      <div class="bta-lista">
        <button
          v-if="!query"
          type="button"
          class="advup-menu__item bta-nenhum"
          @click="emit('assignTeam', semTime)"
        >
          <i class="i-lucide-users-round bta-ico" aria-hidden="true" />
          {{ semTime.name }}
        </button>
        <div v-if="!query" class="advup-menu__filete" />
        <button
          v-for="team in filteredTeams"
          :key="team.id"
          type="button"
          class="advup-menu__item"
          @click="emit('assignTeam', team)"
        >
          <i
            class="i-lucide-users-round bta-ico bta-ico--teal"
            aria-hidden="true"
          />
          <span class="bta-nome">{{ team.name }}</span>
        </button>
        <p v-if="!filteredTeams.length" class="advup-nota bta-nada">
          {{ t('BULK_ACTION.TEAMS.NO_TEAMS_FOUND') }}
        </p>
      </div>
    </template>
    <p v-else class="advup-nota bta-nada">
      {{ t('BULK_ACTION.TEAMS.NO_TEAMS_AVAILABLE') }}
    </p>
  </BulkPopover>
</template>

<style scoped>
.bta-busca {
  flex-shrink: 0;
  margin: 0 var(--esp-2) var(--esp-1);
}

.bta-lista {
  min-height: 0;
  overflow-y: auto;
}

.bta-ico {
  flex-shrink: 0;
  font-size: var(--ico-2);
  color: rgb(var(--slate-10));
}

.bta-ico--teal {
  color: rgb(var(--teal-11));
}

.bta-nenhum {
  color: rgb(var(--slate-11));
}

.bta-nome {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bta-nada {
  margin: 0;
  padding: var(--esp-3);
  text-align: center;
}
</style>
